module.exports = __webpack_public_path__ + "static/pic14-fdffaba3b719d8ab58e8a8152a919530.png";